import { TFormMultiselectProps } from 'cng-common/features/form/components/formMultiselect/models'
import { OnboardingFormMultiselect } from 'onboarding/components/ui/theme'

import { TAdaptingDisabled } from './types'

export const OnboardingFormMultiselectAdapter = <T,>({
  disabled,
  isDisabled,
  ...props
}: TFormMultiselectProps<T> & TAdaptingDisabled) => (
  <OnboardingFormMultiselect {...props} isDisabled={isDisabled || disabled} isStatic />
)
